/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import { useSelector } from "react-redux";

import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";

import {
  Button,
  Grid,
  Hidden,
} from "@material-ui/core";

import brandTheme from "brandTheme/Theme";

import ToastModal from "views/components/ToastModal";

import { useNavigate } from "react-router-dom";
import { getDeviceType } from "utils/Utils";
import { enableGetTheAppButton } from "assets/properties/properties";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    width: "100%",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    [theme.breakpoints.down("sm")]: {
      height: "60px",
      padding: "0",
    },
  },

  mainContainer: {
    display: "flex",
    alignItems: "center",
    gap: "35px",
    color: "#1e293b",
    marginRight: 30,

    [theme.breakpoints.down("md")]: {
      gap: "20px",
    },

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  navItem: {
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "0.3s",
    position: "relative",

    "&:hover": {
      color: brandTheme.primary,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: -6,
      width: 0,
      height: "2px",
      background: brandTheme.primary,
      transition: "0.3s",
    },

    "&:hover::after": {
      width: "100%",
    },
  },

  rightContainer: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      width: "100%",
    },
  },

  applyButton: {
    background:         "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: "#fff",
    borderRadius: "12px",
    textTransform: "none",
    fontWeight: "bold",
    padding: "10px 24px",
    boxShadow: "none",

    "&:hover": {
      background:         "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px",
      fontSize: "12px",
    },
  },

  mobileApplyButton: {
    background: "#3D0A1C",
    color: "#fff",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "12px",
    padding: "6px 12px",
    minWidth: "unset",

    "&:hover": {
      background: "#3D0A1C",
    },
  },

  dateText: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: 500,
    display: "none",

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const DesktopHeaderOuter = ({
  userDetailData,
  mobileView,
}) => {
  const classes = useStyles();

  const navigate = useNavigate();

  const { authToken } = useSelector(
    (state) => state.login.authData
  );

  const [toast, setToast] = useState(false);

  const [toastMessage, setToastMessage] =
    useState("");

  const [toastMessageType, setToastMessageType] =
    useState("");

  const navigateToLoginPage = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
      authToken,
    });

    if (result.data && result.data.main) {
      window.location.href = result.data.main;
    }
  };

  useEffect(() => {
    function storageChange(event) {
      if (event.key === "persist:root") {
        const { login } = JSON.parse(event.newValue);

        const { authData } = JSON.parse(login);

        if (
          authData &&
          !authData.isAuthenticated
        ) {
          navigateToLoginPage();
        }
      }
    }

    window.addEventListener(
      "storage",
      storageChange,
      false
    );

    return function cleanup() {
      window.removeEventListener(
        "storage",
        storageChange
      );
    };
  }, []);

  const toastUpdate = (
    type,
    message,
    showToast
  ) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const formatDate = () => {
    let nDate = new Date().getDate();

    nDate = nDate < 10 ? "0" + nDate : nDate;

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const nMonth =
      monthNames[new Date().getMonth()];

    return `${nDate}-${nMonth}-${new Date().getFullYear()}`;
  };
  const handleLogin = () => {
    sessionStorage.setItem("RepaymentFlag", "false");
    navigate("/login");
  };

  const handleRepay = () => {
    sessionStorage.setItem("RepaymentFlag", "true");
    navigate("/login");
  };
    const device = getDeviceType();
    const enableGetTheAppBtn = enableGetTheAppButton && device !=="ios"
  return (
    <Grid
      container
      className={classes.headerContainer}
    >
      {/* DESKTOP NAVIGATION */}
      {!mobileView && (
        <div className={classes.mainContainer}>
          <span
            className={classes.navItem}
            onClick={() =>
              navigate("/welcome")
            }
          >
            Home
          </span>

          <span
            className={classes.navItem}
            onClick={() =>
              navigate("/about")
            }
          >
            About
          </span>

          <span
            className={classes.navItem}
            onClick={() =>
              navigate("/contact")
            }
          >
            Contact
          </span>
          <span
            className={classes.navItem}
            onClick={handleRepay}
          >
            Repay
          </span>

          <Button
            className={classes.applyButton}
            // onClick={handleLogin}
             onClick={() =>{
                if(enableGetTheAppBtn){
                window.open(
                  "https://play.google.com/store/apps/details?id=com.personalloanapp",
                  "_blank",
                  "noopener,noreferrer"
                )
              }else{
                navigate("/login")
              }
          }
        }
          >
           {enableGetTheAppBtn ? "Get the App" : "Sign In"}
          </Button>
        </div>
      )}

      {/* MOBILE APPLY BUTTON */}
      {/* {mobileView && (
        <Button
          className={classes.mobileApplyButton}
          onClick={() =>
            navigate("/login")
          }
        >
          Apply
        </Button>
      )} */}

      {/* RIGHT SIDE */}
      <div className={classes.rightContainer}>
        {!mobileView && (
          <span className={classes.dateText}>
            {formatDate()}
          </span>
        )}
      </div>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DesktopHeaderOuter.propTypes = {
  mobileView: PropTypes.bool,
};

DesktopHeaderOuter.defaultProps = {
  mobileView: false,
};

export default DesktopHeaderOuter;